module.exports = __webpack_public_path__ + "img/Rectangle 145@2x.843bded6.png";